/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_FIN_BY_COST_ITEM = {
  id: 'finance_by_cost',
  screenId: 'met-fin-by-cost',
  label: 'Flujo de Fondos',
  description: 'Ingresos y egresos por centro de costo.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Visualizás entradas y salidas de dinero agrupadas por centro de costo (árbol jerárquico), con totales y gráficos.',
      },
      {
        title: 'Paso 1 — Período y moneda',
        fields: [
          { label: 'Período', description: 'Atajos o rango personalizado.' },
          { label: 'Moneda', description: 'Filtrá por moneda o todas.' },
        ],
      },
      {
        title: 'Paso 2 — Leer el árbol',
        bullets: [
          'Ingresos y egresos por rubro de centro de costo.',
          'Origen de fondos (caja, banco, etc.) en cajas resumen.',
          'Retenciones/percepciones si aplican en el período.',
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_FIN_INDICATORS_ITEM = {
  id: 'finance_indicators',
  screenId: 'met-fin-indicators',
  label: 'Indicadores',
  description: 'Posición, resultado devengado, flujo de caja y eficiencia.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Tablero ejecutivo con KPIs de liquidez, ventas, compras, margen bruto FIFO, flujo neto, DSO/DPO y evolución de los últimos 6 meses.',
      },
      {
        title: 'CxC y CxP en Indicadores',
        bullets: [
          'Solo incluye saldo pendiente de facturas de clientes y proveedores.',
          'No incluye cheques, cuotas de préstamos, impuestos ni tarjetas propias (ver Compromisos).',
        ],
      },
      {
        title: 'Paso 1 — Período',
        fields: [
          { label: 'Período', description: 'Atajos o rango personalizado.' },
          {
            label: 'Unificar monedas',
            description: 'Convierte totales a ARS usando la cotización vigente en el sistema.',
          },
        ],
      },
      {
        title: 'Paso 2 — Leer los bloques',
        bullets: [
          'Posición comercial — caja, bancos y saldo pendiente solo por facturas al cierre del período.',
          'Resultado devengado — ventas/compras por fecha de comprobante y margen bruto.',
          'Flujo de caja — ingresos/egresos por fecha real de cobro o pago.',
          'Eficiencia — DSO (cobranza) y DPO (pago a proveedores).',
          'Evolución y concentración — gráfico mensual y top clientes/proveedores.',
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_FIN_OBLIGATIONS_ITEM = {
  id: 'finance_obligations',
  screenId: 'met-fin-obligations',
  label: 'Compromisos',
  description: 'Cheques, cuotas, impuestos, F.931 y vencimientos a 30/60/90 días.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Calendario de compromisos de tesorería al corte elegido: cheques a pagar y cobrar, cuotas de préstamos, impuestos, cargas sociales F.931 y resúmenes de tarjetas propias, agrupados por vencido, 0–30, 31–60, 61–90 y más de 90 días.',
      },
      {
        title: 'Paso 1 — Fecha de corte',
        fields: [
          { label: 'Fecha de corte', description: 'Los vencimientos se calculan respecto a esta fecha.' },
          {
            label: 'Unificar monedas',
            description: 'Convierte totales a ARS con la cotización vigente.',
          },
        ],
      },
      {
        title: 'Qué incluye',
        bullets: [
          'Cheques propios emitidos pendientes de débito.',
          'Cuotas de préstamos bancarios con saldo pendiente.',
          'Obligaciones fiscales con saldo adeudado.',
          'Formularios F.931 de cargas sociales con saldo pendiente.',
          'Resúmenes cerrados de tarjetas propias no pagados.',
          'Cheques de terceros en cartera, custodia o depositados.',
        ],
      },
      {
        title: 'Qué no incluye',
        bullets: [
          'Saldos de facturas en cuenta corriente (ver Indicadores).',
          'Cheques endosados, pagados, cobrados o rechazados.',
        ],
      },
    ],
  },
}
